document.body.addEventListener('htmx:wsBeforeMessage', function (event) {
    const message = JSON.parse(event.detail.message);
    const eventName = message.event_name;

    if (eventName == 'update_ui') {
        wsUpdateUI(message);
    }

});